export enum Resource {
  Activity = 'Activity',
  Candidate = 'Candidate',
  CandidateComment = 'CandidateComment',
  CandidateFile = 'CandidateFile',
  ContractType = 'ContractType',
  EmailHistory = 'EmailHistory',
  EmployeeDevice = 'EmployeeDevice',
  Employer = 'Employer',
  EmployerComment = 'EmployerComment',
  EmployerInterviewLocation = 'EmployerInterviewLocation',
  Interview = 'Interview',
  JobPosition = 'JobPosition',
  JobTitle = 'JobTitle',
  Match = 'Match',
  MatchComment = 'MatchComment',
  OvertimeCompensation = 'OvertimeCompensation',
  Permission = 'Permission',
  Role = 'Role',
  ScheduledInvite = 'ScheduledInvite',
  Setting = 'Setting',
  Team = 'Team',
  Template = 'Template',
  WhatsAppMessage = 'WhatsAppMessage',
  WorkHistory = 'WorkHistory',
}
